$(function () {
    const input = document.getElementById("quantity");

    $("#plus").on("click", function () {
        input.value = Number(input.value) + 1;
    });

    $("#minus").on("click", function () {
        if (Number(input.value) > Number(input.min)) {
            input.value = Number(input.value) - 1;
        }
    });
});